import EasyPlanClient from './EasyPlanClient';
import router from "../router/index";
export default {
    loginTime:null,
    loginTimeout:1000*60*60*2,
    loadCompanyInfo(companyAlias, callback = () => { }) {
        console.debug("carico companyInfo");

        EasyPlanClient.Company.FindByAlias(companyAlias)
            .then((res) => {
                console.debug(res);
                console.debug(this.companyInfo);
                localStorage.companyInfo = JSON.stringify(res.data.data);
                callback(res.data.data);
            })
            .catch((error) => {
                console.log(error);
                this.error = EasyPlanClient.GetErrorDescription(
                    error.response.data.errorCode
                );
                console.error(
                    "si è verificato un errore (" +
                    error.response.data.errorCode +
                    ")" +
                    this.error
                );
                console.error(error);
            });
    },
    Logoff(companyAlias, callback = () => { }) {
        console.debug("logging off");
        localStorage.userToken = null;
        localStorage.currentUser = null;
        localStorage.currentCompany = null;
        callback();
        if(companyAlias){
            router.push({
                name: "login",
                params: { companyAlias: companyAlias },
            });
        }
        else{
            router.push({
                name: "login-owner"
            });
        }
       
    },
    IsSessionValid(){
        if(localStorage.loginTime){
            console.debug("llocalStorage.loginTime",localStorage.loginTime);
            this.loginTime= JSON.parse(localStorage.loginTime);
            console.debug("this.loginTime",this.loginTime);
            console.debug("this.loginTimeout",this.loginTimeout);
            console.debug("new Date()- this.loginTime",new Date().getTime()- this.loginTime );
            return (new Date().getTime()- this.loginTime )< this.loginTimeout;
        }
        return false;
    },
    getCurrentUser(){
        
        if (localStorage.currentUser != null){
            let user=JSON.parse(localStorage.currentUser);
            return user;
        }
        else return null;
    }, 
    setCurrentUser(user){
         
            localStorage.currentUser=JSON.stringify(user); 
    },
    checkPermission(permission) {
        let allowed = false;
        
        if (localStorage.currentUser != null){
            let user=JSON.parse(localStorage.currentUser);
            console.debug("currentUser",user);
            if(user.idRuolo==1){ //OWNER
                allowed=true;
            }
            else if (user.ruolo != null){
                
                console.debug("ruolo",user.ruolo);
                if (user.ruolo.permessi != null) 
                {
                    console.debug("permessi",user.ruolo.permessi);
                    allowed= (user.ruolo.permessi.filter(p=>p.idPermesso==permission && p.abilitato)).length>0
                }
            }
        }
            
               
        return allowed;
    },
    checkRedirects(companyAlias){
        if(!this.IsSessionValid()){
            this.Logoff(companyAlias);
                router.push({
                          name: "login",
                          params: { companyAlias:companyAlias  },
                      });
        }
        else  if(!this.checkPermission("SHOW_SIDEBAR"))
                  router.push({
                          name: "agenda-viewer",
                          params: { companyAlias:companyAlias   },
                      });
      },
    loadUserInfo(companyAlias, callback = () => { }) {
        console.debug("carico companyInfo");
        
        EasyPlanClient.User.Find(companyAlias, "current")
            .then((res) => {
                console.debug(res); 
                this.loginTime=new Date().getTime();
                localStorage.loginTime=JSON.stringify(this.loginTime);
                // this.currentUser = res.data.data;
                localStorage.currentUser = JSON.stringify(res.data.data);
                console.debug(this.companyInfo);
                callback(res.data.data);
            })
            .catch((error) => {
                console.log(error);
                this.error = EasyPlanClient.GetErrorDescription(
                    error.response.data.errorCode
                );
                console.error(
                    "si è verificato un errore (" +
                    error.response.data.errorCode +
                    ")" +
                    this.error
                );
                console.error(error);
            });
    }
}